type SvgCacheItem = {
  svgXml: any;
  svgString: string;
};

export type SvgCacheMap = Record<string, SvgCacheItem>;

class SvgCacheManage {
  // 单例实例变量
  private static instance: SvgCacheManage | null = null;

  // 缓存已加载过的svg
  private cacheMap: SvgCacheMap = {};

  // 设置缓存
  public setSvgCache(key: string, svgXml: any, svgString: string) {
    this.cacheMap[key] = {
      svgXml,
      svgString,
    };

    window['cacheMap'] = this.cacheMap;
  }

  // 获取缓存
  public getSvgCache(key: string): SvgCacheItem | undefined {
    return this.cacheMap[key];
  }

  // 获取单例实例的静态方法
  public static getInstance() {
    if (!SvgCacheManage.instance) {
      // 如果实例不存在，则创建
      SvgCacheManage.instance = new SvgCacheManage();
    }
    // 返回单例实例
    return SvgCacheManage.instance;
  }
}

/**
 * @description SVG缓存处理
 */
const svgCache = SvgCacheManage.getInstance();

export default svgCache;
